// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import rdata from './data.json'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function AppsData(props) {
  let data = rdata.value

  return (
    <DataProvider
      context="apps"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}